import { Component, Input, ViewEncapsulation } from '@angular/core';
import { SubscriptionQueryService } from '~app/farp-odq/store/subscription/subscription-query.service';
import { SubscriptionFormViewModel } from '~app/farp-odq/store/subscription/subscription.model';

@Component({
    selector: 'odq-premium-minimum',
    templateUrl: './premium-minimum.component.html',
    styleUrls: ['./premium-minimum.component.scss', '../styles/subscription-forms.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PremiumMinimumComponent {

  @Input() model: SubscriptionFormViewModel;
  constructor(private queryService: SubscriptionQueryService) {

  }
  hasMemberSuprime() {
    return this.model.premiumMinimum.calcSubprime>0;
  }

  hasMemberCredit() {
    return this.model.premiumMinimum.calcCredit<0;
  }
  isMobileMode(): boolean {
    return this.queryService.isMobile();
  }
}